.formError {
  margin: 0;
  color: var(--destructive);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
  text-align: center;
}

@media (max-width: 768px) {
  .formError {
    font-size: var(--font-size-body);
  }
}
